import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from '../components/ui/button';
import BookingWidget from '../components/BookingWidget';
const Bedrooms = () => {
  const { t } = useLanguage();
  const [selected, setSelected] = useState(null);
  const bedrooms = [
    { title: t('bedrooms.bedroom1'), desc: t('bedrooms.bedroom1Desc'), img: '/images/bedroom1.jpg' },
    { title: t('bedrooms.bedroom2'), desc: t('bedrooms.bedroom2Desc'), img: '/images/bedroom2.jpg' },
    { title: t('bedrooms.bedroom3'), desc: t('bedrooms.bedroom3Desc'), img: '/images/bedroom3.jpg' },
    { title: t('bedrooms.bedroom4'), desc: t('bedrooms.bedroom4Desc'), img: '/images/bedroom4.jpg' },
  ];
  return (
    <div data-testid="bedrooms-page" className="min-h-screen pt-24 pb-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <p className="uppercase tracking-widest text-xs text-[#D4A72C] mb-4">Villa Aristotle</p>
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#1E3A5F] mb-6">{t('bedrooms.title')}</h1>
        <p className="text-[#1E3A5F]/70 text-lg max-w-2xl">{t('bedrooms.subtitle')}</p>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {bedrooms.map((bedroom, index) => (
            <div key={index} className="bg-[#f8fafc] border border-[#1E3A5F]/10 rounded-sm overflow-hidden">
              <div className="h-48 overflow-hidden cursor-pointer" onClick={() => setSelected(bedroom)}>
                <img src={bedroom.img} alt={bedroom.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" />
              </div>
              <div className="p-6">
                <h3 className="font-serif text-xl text-[#1E3A5F] mb-2">{bedroom.title}</h3>
                <p className="text-sm text-[#1E3A5F]/60">{bedroom.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="bg-[#1E3A5F] rounded-sm p-8 md:p-12 text-center text-white">
          <h2 className="font-serif text-2xl md:text-3xl mb-4">{t('bedrooms.needInfo')}</h2>
          <p className="text-white/70 mb-8 max-w-xl mx-auto">{t('bedrooms.needInfoText')}</p>
          <Link to="/booking">
            <Button data-testid="bedrooms-book-now-btn" className="bg-[#D4A72C] text-[#1E3A5F] hover:bg-[#D4A72C]/90 btn-lift font-semibold">
              {t('nav.booking')}
              <ChevronRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
      {selected && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setSelected(null)}>
          <img src={selected.img} alt={selected.title} className="max-h-screen max-w-full rounded shadow-xl" />
        </div>
      )}
      <BookingWidget variant="sticky" />
    </div>
  );
};
export default Bedrooms;
